import { Injectable } from '@angular/core';

import { map } from 'rxjs';

import type { IntelligenceSettingsState } from '@core/intelligence-types';
import { injectTellentIntelligenceHttp } from '@core/tellent-http-legacy';

@Injectable({ providedIn: 'root' })
export class IntelligenceSettingsHttp {
  private httpApi = injectTellentIntelligenceHttp();

  public fetch() {
    return this.httpApi
      .get('/settings', null, null)
      .pipe(map((response): IntelligenceSettingsState => response.data));
  }

  public update(state: Partial<IntelligenceSettingsState>) {
    return this.httpApi
      .patch('/settings', null, state)
      .pipe(map((response): IntelligenceSettingsState => response.data));
  }
}
